import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/una/banner_back.webp";

function Banner() {
  return (
    <section
      className="banner_una text_white"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h1>
              Empowering Job Seekers To Connect Quickly & Efficiently With
              Employers
            </h1>
            <p>
              The University of North Alabama, one of the top universities in
              the USA, is known for producing exceptional U.S. Students. Apart
              from its world-class education programs, the University of North
              Alabama also offers great jobs to its students. The purpose of the
              UNA Job Portal mobile application was to serve as a platform that
              helps student find the right job and kick-start their career
              confidently
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/una/banner_img.webp"
                alt="TekRevol"
                className=""
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={717}
                height={738}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
